import {Routes} from "@angular/router";
import {AuthenticationGuard, AuthorizationGuard} from '@softline/auth';
import { SOFTLINE_PERMISSION_WWS_BASISARTIKELSTAND } from "./basisartikelstand.shared";

export const basisartikelstandRoutes: Routes = [
  {
    path: 'basisartikelstand',
    loadComponent: () => import('./pages/basisartikelstand.component').then(c => c.BasisartikelstandComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/uebersicht/uebersicht.component').then(c => c.UebersichtComponent)
      }
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_WWS_BASISARTIKELSTAND },
  }
];
